"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getTransaction = void 0;
const eth_1 = require("../../lib/eth");
const types_1 = require("./types");
function getTransaction(address, chainId, hash) {
    return __awaiter(this, void 0, void 0, function* () {
        const provider = yield eth_1.getNetworkProvider(chainId);
        if (!provider) {
            console.log('provider null');
            return null;
        }
        const tronWeb = window.tronWeb;
        if (tronWeb === undefined) {
            console.log('tronWeb null');
            return null;
        }
        // const eth = new Eth(provider)
        if (!address) {
            console.log('address null');
            return null;
        }
        // let currentNonce: number | null = null
        // try {
        //   currentNonce = await eth.getTransactionCount(Address.fromString(address))
        // } catch (error) {
        //   console.warn(
        //     `Could not get current nonce for account "${address}"`,
        //     error.message
        //   )
        // }
        let trxTransaction = null;
        const response = new (class {
        })();
        const receipt = new (class {
        })();
        response.hash = hash;
        try {
            // @ts-ignore
            trxTransaction = yield tronWeb.trx.getTransaction(hash);
        }
        catch (error) {
            console.log('fucking motherfuckfing thgryeeyye');
            console.warn(`Could not get transaction for hash "${hash}"`, error.message);
            return Object.assign({ status: types_1.TransactionStatus.PENDING }, response);
        }
        console.log('before ret');
        console.log(trxTransaction);
        if (trxTransaction.ret === undefined) {
            return Object.assign({ status: types_1.TransactionStatus.PENDING }, response);
        }
        let contractRet = trxTransaction.ret[0].contractRet;
        console.log('RET: ' + contractRet);
        // if (response.blockNumber == null) {
        //   if (currentNonce != null) {
        //     // replaced
        //     if (response.nonce < currentNonce) {
        //       const tx: ReplacedTransaction = {
        //         hash,
        //         status: TransactionStatus.REPLACED,
        //         nonce: response.nonce
        //       }
        //       return tx
        //     }
        //
        //     // queued
        //     if (response.nonce > currentNonce) {
        //       const tx: QueuedTransaction = {
        //         hash,
        //         status: TransactionStatus.QUEUED,
        //         nonce: response.nonce
        //       }
        //       return tx
        //     }
        //   }
        if (contractRet === 'SUCCESS') {
            receipt.status = true;
            receipt.transactionHash = hash;
            return Object.assign(Object.assign({ status: types_1.TransactionStatus.CONFIRMED }, response), { receipt });
        }
        else {
            return Object.assign({ status: types_1.TransactionStatus.REVERTED }, response);
        }
    });
}
exports.getTransaction = getTransaction;
//# sourceMappingURL=txUtils.js.map